module.exports = {
      id: "sponsor-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#sponsor",
      toString: function () {
        return this.url;
      }
    }